import React, { useState, useEffect } from 'react'
import { NoRecords } from '../../../lib/loader'
import Table from '@mui/material/Table';
import close from '../../../assets/images/icons/close-circle.svg'
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useGetHomeCms } from '../api/homepageApi';
import { Edit } from 'lucide-react';
import { Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import EditCardList from './EditCardList';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { WaitingLoader } from '../../../hooks/buttonLoad';

function HomeCardList() {

    const [editdata, setEditdata] = useState();
    const { data: getCms, isLoading } = useGetHomeCms()
    const homeCard = getCms?.data?.cms[3]

    const [isedit, setIsedit] = useState(false)
    const toggleEdit = () => {
        setIsedit(!isedit)
    }

    const handleEdit = (item) => {
        setEditdata(item);
        toggleEdit()
    }

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Homepage Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };



    let tableContent;

    if (getCms?.data?.cms?.length > 0) {
        tableContent = (
            <div style={{ minHeight: "60vh" }}>
                <div className='table-responsive'>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align='center' style={{ maxWidth: "60px" }}>S.NO</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Date & Time</TableCell>
                                <TableCell align='center'>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key={homeCard?._id}>
                                <TableCell align='center'>1</TableCell>
                                <TableCell>{homeCard?.heading}</TableCell>
                                <TableCell>
                                    {moment(homeCard?.updatedAt).format("DD/MM/YYYY | hh:mm A")}
                                </TableCell>
                                <TableCell align='center'>
                                    <div className='d-flex justify-content-center'>
                                        <Edit
                                            className="mx-3"
                                            size={20}
                                            type='button'
                                            onClick={() => handleEdit(homeCard)}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    } else {
        tableContent = <NoRecords />;
    }

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <section>
                <h4>Content Management</h4>
                <br />
                <br />
                <div className="ad_pg_bx bg-white p-3">
                    {tableContent}
                </div>

                <Modal isOpen={isedit} toggle={toggleEdit} centered>
                    <div className="modal-header">
                        <h1 className="modal-title fs-10">CMS Management</h1>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={toggleEdit}
                            aria-label="Close"
                        >
                            <img src={close} alt="close-circle" />
                        </button>
                    </div>
                    <ModalBody>
                        <EditCardList editData={editdata} toggleEdit={toggleEdit} />
                    </ModalBody>
                </Modal>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}


export default HomeCardList